import React, {useEffect, useRef, useState} from "react";
import {CircularProgress} from "@material-ui/core";
import {BingoCountdownTypography} from "../BingoCountdownTypography";

const useCountdown = (callback, delay = 1000) => {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        const tick = () => {
            savedCallback.current();
        };

        let id = setInterval(tick, delay);
        return () => clearInterval(id);
    }, []);
};

export const BingoCountdownTimer = (props) => {
    const [timeRemaining, setTimeRemaining] = useState(props.seconds);

    useEffect(() => {
        if (props.seconds > 0) {
            setTimeRemaining(props.seconds);
        }
    }, [props.seconds]);

    const tick = () => {
        if (timeRemaining > 0) {
            setTimeRemaining(timeRemaining - 1);
        }
    };

    useCountdown(tick);

    let seconds = timeRemaining;
    let hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;
    let minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;

    if (minutes < 10) {
        minutes = `0${minutes}`;
    }

    if (seconds < 10) {
        seconds = `0${seconds}`;
    }

    if (hours < 10) {
        hours = `0${hours}`;
    }

    let counter = `${hours > 0 ? `${hours}:` : ''}${minutes}:${seconds}`;

    if (timeRemaining > 0) {
        return (
            <BingoCountdownTypography small>
                {counter}
            </BingoCountdownTypography>
        );
    }

    return <CircularProgress style={{display: "flex"}} size={16}/>
};
